// extracted by mini-css-extract-plugin
export default {"dialogContent":"SendCustomMessagesToUsers_dialogContent__0bTQk"};